import { type AppConfig as AppConfigType, nfcConfig, ngeConfig } from "../../../../shared/app-config";

class AppConfigService {
  private hideWipFeatures = import.meta.env.VITE_HIDE_WIP_FEATURES?.toUpperCase() === "TRUE";
  private _brandConfig: AppConfigType;

  constructor() {
    this._brandConfig = this.getAppConfig();
  }

  private getAppConfig(): AppConfigType {
    const configType = import.meta.env.VITE_APP_CONFIG || "nfc";

    switch (configType.toLowerCase()) {
      case "nge":
        return ngeConfig;
      default:
        return nfcConfig;
    }
  }

  public get brandConfig(): AppConfigType {
    return this._brandConfig;
  }

  public get apiUrl(): string {
    return "";
  }

  public get shouldHideWipFeatures(): boolean {
    return this.hideWipFeatures;
  }

  public get canShowWipFeatures(): boolean {
    return !this.hideWipFeatures;
  }

  public get isProd(): boolean {
    return import.meta.env.PROD;
  }
}

export const AppConfig = new AppConfigService();
